// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2FHS8","info":"PatientInfo_info__3S2Xg"};